import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';

import config from "../../../../../../server/src/config";

import * as RaceActions from "../../../../actions/race";
import * as AdminActions from "../../../../actions/admin";
import {CompressList, isDefined, nullToBlank} from "../../../../../../common/src/util/lib";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class RaceList extends React.Component {
    static propTypes = {
        selectedRaces: PropTypes.array.isRequired,
        updateSelection: PropTypes.func.isRequired,
        filterRaces: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = Object.assign({
            initialized: false,
        });
    }

    componentDidMount() {
        this.props.dispatch(RaceActions.getRaces());
        this.props.dispatch(AdminActions.getListItems('station'));
    }

    fields = [];
    render() {
        const week = isDefined(this.props.location) && isDefined(this.props.location.query.week) && /^[0-9]{1,2}$/.test(this.props.location.query.week) ? Number(this.props.location.query.week) : moment(new Date()).isoWeek();
        let raceWeek = null;
        let raceId = null;
        const result = this.props.race.isRacesRead ? <table className="data-table row-clickable">
            <thead>
                <tr>
                    <th scope="row" onClick={(e) => {
                        e.stopPropagation();
                        this.props.updateSelection(this.props.race.races.map(race => race.Nr).toArray(), this.props.selectedRaces.length < this.props.race.races.count())
                    }}></th>
                    <th>Uge</th>
                    <th>Farvekode</th>
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <th>Grupper</th> : null}
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <th>Sektioner</th> : null}
                    <th>Station</th>
                    <th>Navn</th>
                    <th>Slipdato</th>
                    <th>Sliptid</th>
                </tr>
            </thead>
            <tbody>
                {this.props.race.races.filter(race => typeof(this.props.filterRaces) === "undefined" ? true : this.props.filterRaces(race)).sort((r1, r2) => {
                    if (r1.Uge < r2.Uge) return -1;
                    if (r1.Uge > r2.Uge) return 1;
                    if (r1.Farvekode < r2.Farvekode) return -1;
                    if (r1.Farvekode > r2.Farvekode) return 1;
                    if (nullToBlank(r1.Sektion) < nullToBlank(r2.Sektion)) return -1;
                    if (nullToBlank(r1.Sektion) > nullToBlank(r2.Sektion)) return 1;
                    if (nullToBlank(r1.Sektionsgrupper) < nullToBlank(r2.Sektionsgrupper)) return -1;
                    if (nullToBlank(r1.Sektionsgrupper) > nullToBlank(r2.Sektionsgrupper)) return 1;
                    if (nullToBlank(r1.Sektioner) < nullToBlank(r2.Sektioner)) return -1;
                    if (nullToBlank(r1.Sektioner) > nullToBlank(r2.Sektioner)) return 1;
                    return 0;
                }).toArray().map(race => {
                    if (raceWeek === null || race.Uge <= week) {
                        raceWeek = race.Uge;
                        raceId = race.Nr;
                    }
                    const kfk = race.Farvekode.substr(0, 2);
                    const sections = CompressList(race.Sektioner);
                    const groups = CompressList(race.Sektionsgrupper);
                    const station = this.props.admin.stations.get(race.Station);
                    return <tr key={race.Nr} id={'row-' + race.Nr} onClick={() => {
                        this.props.updateSelection([race.Nr], this.props.selectedRaces.indexOf(race.Nr) < 0)
                    }}>
                        <th scope="row"><input type="checkbox" checked={this.props.selectedRaces.indexOf(race.Nr) >= 0}/></th>
                        <td onClick={(e) => {
                            e.stopPropagation();
                            this.props.updateSelection(this.props.race.races.filter(otherRace => otherRace.Uge === race.Uge).map(race => race.Nr).toArray(), this.props.selectedRaces.indexOf(race.Nr) < 0)
                        }}><a href="javascript:void(0)">{race.Uge}</a></td>
                        <td onClick={(e) => {
                            e.stopPropagation();
                            this.props.updateSelection(this.props.race.races.filter(otherRace => otherRace.Uge === race.Uge && otherRace.Farvekode === race.Farvekode).map(race => race.Nr).toArray(), this.props.selectedRaces.indexOf(race.Nr) < 0)
                        }}><a href="javascript:void(0)">{race.Farvekode}</a></td>
                        {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <td>{groups.items.join(',')}</td> : null}
                        {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <td>{sections.items.join(',')}</td> : null}
                        <td>{race.Station}</td>
                        <td>{station ? station.Navn : null}</td>
                        <td>{race.SlipDato === null ? null : moment(race.SlipDato).format(config.formats.dateFormat)}</td>
                        <td>{race.Sliptid}</td>
                    </tr>
                })}
            </tbody>
        </table> : null;

        // Scroll to relevant week.
        if (!this.state.initialized && raceId !== null) setTimeout(function () {
            const currentRow = document.getElementById("row-" + raceId);
            currentRow.scrollIntoView(false);
            this.setState({initialized: true});
        }.bind(this));

        return result;
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        stations: state.admin.stations,
    },
    race: {
        isRacesRead: state.race.isRacesRead,
        races: state.race.races
    }
});

export default connect(mapStateToProps, null, null, {withRef: true})(RaceList);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/common/RaceList.js